<div class="{{ card_view ? 'card-1 payment-pin-config m-auto' : '' }}">
  <div class="dotted-loader" [hidden]="!currentUserLoading"></div>
  <div *ngIf="!currentUserLoading">
    <div class="row">
      <div class="col-12">
        <!--        <h3 class='text-center' [hidden]='otpScreen'>{{ currentUser?.isPinAvailable ? 'Reset Your PIN' : 'Please enter a new PIN' }}</h3>-->
        <p class="pin-note text-center" *ngIf="pinScreen && !mfa">
          {{ translate.currentLang === 'en' ? 'This PIN will be required every time when make payments.' : 'পেমেন্ট করার
          সময় প্রতিবার এই PIN প্রয়োজন হবে।' }} <span>{{ translate.currentLang === 'en' ? 'So don\'t forget it!' : 'তাই
            এটি ভুলবেন না!' }}</span>
        </p>
        <p class="pin-note text-center" *ngIf="mfa && pinScreen">
          {{ translate.currentLang === 'en' ? 'If you configured this PIN, the PIN will be required every time when you
          log into your account.' : 'আপনি যদি এই PIN কনফিগার করেন, তাহলে আপনার অ্যাকাউন্টে লগইন করার সময় প্রতিবার PIN
          প্রয়োজন হবে।' }} <span>{{ translate.currentLang === 'en' ? 'So don\'t forget it!' : 'তাই এটি ভুলবেন না!'
            }}</span>
        </p>
        <div class="error" [hidden]="!errorMsg">
          {{ errorMsg }}
        </div>
        <div class="success" [hidden]="!successMsg">{{ successMsg }}</div>
      </div>
    </div>
    <span *ngIf="currentUser?.isPinAvailable; then resetScreen; else newScreen"></span>
    <ng-template #resetScreen>
      <div class="row124 pin_screen" *ngIf="!pinScreen">
        <app-otpscreen *ngIf="otpScreen" [currentUser]="currentUser" (sentOTPSuccess)="successfullySentOTP($event)">
        </app-otpscreen>
      </div>
      <div class="row123" *ngIf="pinScreen && !successMsg">
        <app-pin-enter-screen [mfa]="mfa" [currentUser]="currentUser" (returnPin)="returnPin($event)">
        </app-pin-enter-screen>
      </div>
    </ng-template>
    <ng-template #newScreen>
      <div class="new-screen">
        <div *ngIf="!successMsg && !otpScreen">
          <div class="dotted-loader" [hidden]="!savingPin"></div>
          <app-pin-enter-screen [hidden]="savingPin" [mfa]="mfa" [currentUser]="currentUser"
            (returnPin)="returnPin($event)">
          </app-pin-enter-screen>
        </div>
        <app-otpscreen [newPin]="'true'" *ngIf="otpScreen" [currentUser]="currentUser"
          (sentOTPSuccess)="successfullySentOTP($event)">
        </app-otpscreen>
      </div>
    </ng-template>
  </div>
</div>